import { env } from "./env";
import { supabase } from "./supabase";

/** API hata yanıtı: { error: { code, details } } (400 biçim, 401/403 yetki, 404, 409 durum, 422 kural) */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    readonly details: Record<string, unknown> | undefined,
  ) {
    super(`${status} ${code}${details?.reason ? ` (${String(details.reason)})` : ""}`);
  }
  get reason(): string | undefined {
    return typeof this.details?.reason === "string" ? this.details.reason : undefined;
  }
}

interface Options {
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  body?: unknown;
  /** para/durum değiştiren uçlar Idempotency-Key ister; bir kullanıcı eylemi = bir anahtar */
  idempotencyKey?: string;
  signal?: AbortSignal;
  /** testte sahte fetch */
  fetchImpl?: typeof fetch;
}

async function token(): Promise<string | null> {
  const { data } = await supabase().auth.getSession();
  return data.session?.access_token ?? null;
}

async function request(path: string, o: Options = {}): Promise<Response> {
  const t = await token();
  const headers: Record<string, string> = {};
  if (t) headers.authorization = `Bearer ${t}`;
  if (o.body !== undefined) headers["content-type"] = "application/json";
  if (o.idempotencyKey) headers["idempotency-key"] = o.idempotencyKey;
  const res = await (o.fetchImpl ?? fetch)(`${env.apiUrl}${path}`, {
    method: o.method ?? "GET",
    headers,
    ...(o.body !== undefined ? { body: JSON.stringify(o.body) } : {}),
    ...(o.signal ? { signal: o.signal } : {}),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as {
      error?: { code?: string; details?: Record<string, unknown> };
    } | null;
    throw new ApiError(res.status, body?.error?.code ?? "HTTP_ERROR", body?.error?.details);
  }
  return res;
}

export async function api<T>(path: string, o: Options = {}): Promise<T> {
  const res = await request(path, o);
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

/** Dosya indirme (CSV): yanıtı kaydettirir; adı sunucudan */
export async function download(path: string): Promise<void> {
  const res = await request(path);
  const blob = await res.blob();
  const name =
    /filename="([^"]+)"/.exec(res.headers.get("content-disposition") ?? "")?.[1] ?? "export.csv";
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}

export const newIdempotencyKey = () => crypto.randomUUID();
